export type Placement = 'left' | 'top' | 'right' | 'bottom';

export enum GraphQLErrorMessage {
  INTERNAL_SERVER_ERROR = 'Internal server error',
  NOT_FOUND = 'Not Found',
  FORBIDDEN = 'Forbidden',
}

export enum SORT_DIRECTION {
  ASC = 'asc',
  DESC = 'desc',
}

export type SortEvent<T> = {
  columnId: T;
  sortDirection: SORT_DIRECTION;
};
